import { Component, computed, input } from '@angular/core';

import { ImageComponent } from '@valk-nx/components/ui-image/src/lib/image.component';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';

import type { SliderConfig } from '../slider.interface';

/**
 * What a slider of asymmetric image slides needs from its config: the slides
 * size themselves and run edge to edge, and each step forward reveals one new
 * slide at the right instead of pushing the leftmost one out.
 */
export const ASYMMETRIC_SLIDER_CONFIG: SliderConfig = {
	slidesPerView: 'auto',
	edgeOffset: 0,
	breakpoints: {},
	snapAlign: 'end',
};

/** The tailwind aspect ratios the rhythm cycles through: 3:2, 3:4, 1:1. */
export type AsymmetricSlideShape = 'film' | 'portrait' | 'square';

const SHAPE_RHYTHM: AsymmetricSlideShape[] = ['film', 'portrait', 'square'];

@Component({
	selector: 'vp-asymmetric-image-slide',
	templateUrl: './asymmetric-image-slide.html',
	imports: [ImageComponent],
	host: { class: 'contents' },
})
export class AsymmetricImageSlideComponent {
	readonly image = input.required<PhotoInterface>();
	readonly index = input.required<number>();

	readonly shape = computed(
		() => SHAPE_RHYTHM[this.index() % SHAPE_RHYTHM.length],
	);
}
